import { render } from "./NumberFormPage.vue?vue&type=template&id=5aa8f7cd&ts=true"
import script from "./NumberFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./NumberFormPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/number/NumberFormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5aa8f7cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5aa8f7cd', __exports__)) {
    api.reload('5aa8f7cd', __exports__)
  }
  
  module.hot.accept("./NumberFormPage.vue?vue&type=template&id=5aa8f7cd&ts=true", () => {
    api.rerender('5aa8f7cd', render)
  })

}


export default __exports__